import { createFileRoute, Outlet } from '@tanstack/react-router';
import { t } from '@lingui/core/macro';

export const Route = createFileRoute('/dispensers')({
  component: Outlet,
  loader: () => {
    return {
      breadcrumb: t`Dispensers`,
    };
  },
});
